var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.698 19.9766H5.38281C4.83053 19.9766 4.38281 20.4243 4.38281 20.9766V41.0009C4.38281 41.5532 4.83053 42.0009 5.38281 42.0009H38.698C39.2503 42.0009 39.698 41.5532 39.698 41.0009V20.9766C39.698 20.4243 39.2503 19.9766 38.698 19.9766Z",
    stroke: "#703BDA",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.081 11.3281H3C2.44772 11.3281 2 11.7758 2 12.3281V18.9737C2 19.526 2.44771 19.9737 3 19.9737H41.081C41.6333 19.9737 42.081 19.526 42.081 18.9737V12.3281C42.081 11.7758 41.6333 11.3281 41.081 11.3281Z",
    stroke: "#703BDA",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.912 10.8931H17.4792C15.0315 10.8931 13.0508 8.89999 13.0508 6.44656C13.0508 3.98879 15.0358 2 17.4792 2C19.927 2 21.9077 3.99314 21.9077 6.44656V10.8931H21.912Z",
    stroke: "#703BDA",
    strokeWidth: 3.3542,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1641 10.8931H26.5925C29.0403 10.8931 31.021 8.89999 31.021 6.44656C31.021 3.98879 29.0359 2 26.5925 2C24.1448 2 22.1641 3.99314 22.1641 6.44656V10.8931V10.8931Z",
    stroke: "#703BDA",
    strokeWidth: 3.3542,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9648 11.6641V41.5437",
    stroke: "#703BDA",
    strokeWidth: 3.0934,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.a179c92aace5c41086d86cdcff8517e2.svg";
export { ForwardRef as ReactComponent };